/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：475
 */

module.exports = {
  courseDialog: "styles_courseDialog__2laZ_",
  courseList: "styles_courseList__1_O8S",
  courseItem: "styles_courseItem__21iVv",
  courseImage: "styles_courseImage__2t3Gu",
  image: "styles_image__22pF9",
  mask: "styles_mask__3zTrH",
  playBox: "styles_playBox__v90Jy",
  courseName: "styles_courseName__3E040",
  courseDesc: "styles_courseDesc__3xuQn",
  courseMore: "styles_courseMore__2Prh3",
  moreImage: "styles_moreImage__2LeuN",
  moreTips: "styles_moreTips__18-Vk"
}
